import { filtersData } from '../constants/filtersData';

export const getFilteredRequests = ({ filterValues, requests = [] }) => {
  const filteredRequests = Object.entries(filterValues).reduce(
    (filteredRequests, [key, value]) => {
      return filtersData[key].filter(filteredRequests, value);
    },
    requests
  );

  return filteredRequests;
};
